export default "__VITE_ASSET__DmrpILU6__"